import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=35517f5e&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=35517f5e&prod&lang=css"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=35517f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35517f5e",
  null
  
)

export default component.exports